<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1bPIY7/media/FC-9781035823963.jpg?1708094026290" alt="This image is the cover for the book The Magic Toy Shop"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Magic Toy Shop
      </h1>
      <p class="bookDescription body article font2">
        <p>The book is a children’s fairy tale about toys with magic powers. A toy shop hidden in an old village deep in the countryside is rumoured to have magic powers. Every toy that enters the toy shop, either to be mended or sold is given the power to move and talk to other toys. But the magic power only happens when children and adults are not around. The children that live in the village somehow know that that is true, without having any real proof. All the parents are convinced that it is the children spreading the rumours, until they experience strange happens with their children’s toys. Many of the toys have their own story to tell, including dolls, robots and unicorns, as well as the children who own them and Nancy and Tom, the shop owners Michael’s dad is determined the find out the truth about  these magic powers and secretly sets up a video camera in his son’s play room during the night, with the story ending with a surprising twist.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter King
      </h2>
      
      <p class="authorDescription body article">Peter King has always been interested in writing, and decided to take his interest further by writing a book during the COVID-19 lockdowns from his job as a Teaching Assistant at a primary school. Prior to working at a school, he trained as a design draughtsman, working on domestic and industrial controls. Another passion of his is sport—Peter is a keen badminton player and golfer. He also enjoys angling and following football and cricket. Peter spends as much time with his grandchildren, who share the same interests. Being a father and a grandfather, this has given him plenty of experiences that he has been able to build into his book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01c4a2f5